import { atomWithReset } from 'jotai/utils';

import { MedicineNoteNotificationPanelState, QrCodeReaderDialog } from './types';

export const medicineNoteNotificationPanelState = atomWithReset<MedicineNoteNotificationPanelState>(
  {
    isOpen: false,
    page: 1,
    perPage: 6,
    totalPage: 1,
    totalCount: 0,
  },
);

export const qrCodeReaderDialogState = atomWithReset<QrCodeReaderDialog>({
  isOpen: false,
});
